export const ScrollWrapper: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ style, children, ...rest }) => (
  <div
    style={{
      width: '100%',
      overflow: 'auto',
      maxHeight: '100vh',
      ...style,
    }}
    {...rest}
  >
    {children}
  </div>
);
